export const FULL_DAY = 24 * 60 * 60;
export const TIME_LABEL_WIDTH = 55;
export const INTERVAL_HEIGHT = 63;
export const SEGMENT_WIDTH = 201;
export const DELAY_TIME_INDICATOR = 1000;
export const OFFICE_OPEN_HOUR = 8;
export const OFFICE_CLOSED_HOUR = 17;
